import ProviderList from "./provider-list/ProviderList.vue";
import providerService from '../../services/provider/ProviderService';
import i18n from "../../i18n/index";

export default {
    components: {
        ProviderList
    },
    data: () => ({
        hideList: false,
        editProccess: false,
        Provider: {
            id: '',
            name: '',
            fiscalNumber: '',
            active: ''
        },
        update: 0,
        rules: [value => !!value || i18n.t('field-required')],
        validForm: true,
        chkProvider: false,
        loadingDelete: false,
        loadingSaveButton: false,
        showAdd: true,
        showIcon: false,
        showUpdate: false,
        showDelete: false
    }),
    created() {},
    methods: {
        handleProvider(item) {
            this.hideList = true;
            this.Provider.id = item.id;
            this.Provider.name = item.name;
            this.Provider.fiscalNumber = item.fiscalNumber;
            this.chkProvider = item.active;
            this.update = 1;
            this.loadingSaveButton = false;
            this.loadingDelete = false;
            this.showAdd = false;
            this.showIcon = false;
            this.showUpdate = true;
            this.showDelete = true;
        },
        closeProvider() {
            this.hideList = false;
            this.dialog = false;
            this.Provider = {
                id: null,
                name: '',
                fiscalNumber: '',
                active: ''
            }
            this.$refs.providerform.reset();
            this.loadingSaveButton = false;
            this.update = 0;
            this.showAdd = true;
            this.showUpdate = false;
            this.showIcon = false;
            this.showDelete = false;
        },
        save() {
            if (!this.$refs.providerform.validate()) {
                this.$notify({
                    group: "app",
                    type: "error",
                    text: i18n.t("app.error-required-fields")
                });
                return;
            }
            this.loadingSaveButton = true;
            this.editProccess = false
            providerService.createProviders(this.Provider)
                .then(result => {
                    if (result.status === 200 || result.status === 201  ) {
                        this.$notify({
                            group: "app",
                            type: "success",
                            text: i18n.t("record-successfully-created")
                        });
                        this.$refs.ProviderList.searchProviders();
                        this.closeProvider();
                        this.loadingSaveButton = false;
                    }
                })
                .catch(err => {
                    this.loadingSaveButton = false;
                    throw err;
                });
        },
        updateProvider() {
            let providerId = this.Provider.id;
            this.Provider.active = this.chkProvider;
            let data = {
                name: this.Provider.name,
                fiscalNumber: this.Provider.fiscalNumber,
                active: this.Provider.active == true ? 1 : 0,
            };
            this.loadingSaveButton = true;
            this.showIcon = true;

            providerService.updateProviders(providerId, data).then(result => {
                this.loadingSaveButton = false;
                if (result.status === 200 || result.status === 201  ) {
                    this.$notify({
                        group: "app",
                        type: "success",
                        text: "Actualizado"
                    });
                    this.$refs.ProviderList.searchProviders();
                    this.closeProvider();
                    this.loadingSaveButton = false;
                }
            }).catch(error => {
                this.loadingSaveButton = false;
                this.showIcon = false;
                if (error && error.code) {
                    if (error) {
                        this.$notify({
                            group: "app",
                            type: "error",
                            text: "el proveerdor tiene transacciones"
                        })
                    }
                }
                this.$refs.ProviderList.searchProviders();
                this.closeProvider();
            });
        },
        deteleProvider() {
            let data = { id: this.Provider.id };
            this.loadingDelete = true;
            providerService.deleteProviders(data).then(result => {
                if (result.status == 200) {
                    this.loadingDelete = false;
                    this.$notify({
                        group: "app",
                        type: "success",
                        text: 'Proveedor Eliminado'
                    });
                    this.$refs.ProviderList.searchProviders();
                    this.closeProvider();
                }
            }).catch(error => {
                this.loadingDelete = false;
                this.showIcon = false;
                if (error && error.code) {
                    if (error.code == 'The providers has associated transactions') {
                        this.$notify({
                            group: "app",
                            type: "error",
                            text: "El proveedor tiene transacciones no se puede eliminar"
                        })
                    }
                }
                this.$refs.ProviderList.searchProviders();
                this.closeProvider();
            });
        }
    }
}